<script>
export default {
    computed: {
        shouldShowDropdown() {
            return this.focused && this.resourcesFound.length > 0
        },
        resultsInlineStyles() {
            let style = `max-height: ${this.height}px;`
            style += this.position === 'top' ? 'bottom: 105%;' : 'top: 105%;'
            return style
        },
    },
    data() {
        return {
            query: '',
            focused: false,
            resourcesFound: [],
            selectedResource: null,
            intervalId: null,
        }
    },
    props: {
        resourceClass: {
            type: Function,
            required: true,
        },
        label: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        timeout: {
            type: Number,
            default: 500,
        },
        name: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        description: {
            type: String,
        },
        position: {
            type: String,
            default: 'bottom',
        },
        blurOnSelect: {
            type: Boolean,
            default: true,
        },
        height: {
            type: [Number, String],
            default: 120,
        },
        filter: {
            type: Function,
            default() {
                return (item) => true
            },
        },
        sort: {
            type: Function,
        },
    },
    watch: {
        query(val) {
            if (this.intervalId) {
                clearInterval(this.intervalId)
            }

            this.resourcesFound = []
            this.intervalId = setTimeout(() => this.search(val), this.timeout)
        },
    },
    methods: {
        async search(query) {
            let ResourceClass = this.resourceClass
            let result = await ResourceClass.search(query)
            this.resourcesFound = result.resources.filter(this.filter)

            if ('function' === typeof this.sort) {
                this.resourcesFound.sort(this.sort)
            }
        },
        reset() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
            }

            this.clear()
        },
        clear() {
            this.resourcesFound = []
            this.query = ''
            this.selectedResource = null
        },
        onKeyDown(e) {
            let key = event.key || event.keyCode
            if (key.toLowerCase() === 'enter' || key.toLowerCase() === 'return') {
                e.preventDefault()

                if (this.resourcesFound.length > 0) {
                    this.onSelect(this.resourcesFound[0])
                }
            }
        },
        onSelect(resource) {
            this.$emit('select', resource)
            this.selectedResource = resource
            this.query = ''
            if (this.blurOnSelect) {
                this.$refs.query.blur()
            }
        },
        onFocus() {
            this.focused = true
            this.search()
        },
        onBlur() {
            setTimeout(() => (this.focused = false), 200)
        },
    },
}
</script>

<template>
    <div class="resource-search">
        <fieldset class="form-group">
            <legend v-if="label || $slots.label" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">
                <slot name="label">
                    {{ label }}
                </slot>
            </legend>
            <div tabindex="-1" role="group" class="bv-no-focus-ring search-inner">
                <input
                    ref="query"
                    :name="name"
                    :placeholder="placeholder"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    v-model="query"
                    :required="required"
                    @keydown="onKeyDown"
                    @focus="onFocus"
                    @blur="onBlur"
                />
                <slot name="description">
                    <small v-if="description" class="form-text text-muted mb-2">{{ description }}</small>
                </slot>
                <slot> </slot>
                <slot name="results" :results="resourcesFound" v-if="shouldShowDropdown">
                    <div class="results" :style="resultsInlineStyles">
                        <ul class="list-unstyled">
                            <li v-for="(resource, i) in resourcesFound" :key="i">
                                <slot name="result" :resource="resource" :index="i">
                                    <a href="javascript:{};" @click.prevent="onSelect(resource)" class="result-item">{{ resource }}</a>
                                </slot>
                            </li>
                        </ul>
                    </div>
                </slot>
            </div>
        </fieldset>
    </div>
</template>

<style lang="scss" scoped>
.search-inner {
    position: relative;

    .results {
        width: 100%;
        position: absolute;
        z-index: 1000;
        background: #fff;
        overflow-y: scroll;
        box-shadow: -3px 4px 5px #eee;
        border-radius: 4px;
        border: 1px solid #ced4da;

        ul {
            margin: 0;
        }

        li {
            border-bottom: 1px solid #ced4da;

            &:last-child {
                border-bottom: none;
            }
        }

        a.result-item {
            display: block;
            padding: 5px 10px;

            &:hover,
            &.active {
                text-decoration: none;
                color: #fff;
                background-color: #633991;
                border-color: transparent;
            }
        }
    }
}
</style>
